import { FirebaseApp } from 'firebase/app';
import { EMAIL_PAGE_BUILDER_PATH, PageBuilderEmail } from '@ag-common-lib/lib/models/email/email-page-builder.model';
import { DataService } from 'ag-common-svc/lib/services/data.service';
import { Inject, Injectable } from '@angular/core';
import { FIREBASE_APP } from 'ag-common-svc/lib/injections/firebase-app';

@Injectable({
  providedIn: 'root',
})
export class EmailPageBuilderService extends DataService<PageBuilderEmail> {
  private collectionPath = EMAIL_PAGE_BUILDER_PATH;

  constructor(@Inject(FIREBASE_APP) fireBaseApp: FirebaseApp) {
    super(fireBaseApp);
    super.setCollection(this.collectionPath);
  }

  async sendEmail(data: PageBuilderEmail) {
    const email = await this.create(data).catch(e => {
      console.log('e', e);
    });

    return email;
  }
}
